import { __assign, __extends } from "tslib";
import React from "react";
var SVG = /** @class */ (function (_super) {
    __extends(SVG, _super);
    function SVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVG.prototype.render = function () {
        return React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "25", height: "25", viewBox: "0 0 24 24" }, this.props),
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("path", { stroke: "#FFF", d: "M12 23.5c6.351 0 11.5-5.149 11.5-11.5S18.351.5 12 .5c-1.216 0-2.406.189-3.539.555A11.504 11.504 0 0 0 .5 12c0 6.351 5.149 11.5 11.5 11.5z" }),
                React.createElement("path", { fill: "#FFF", d: "M15.957 11.805L9.08 15.827V7.784z" })));
    };
    return SVG;
}(React.Component));
export default SVG;
